/**
 * @generated SignedSource<<2a57b0ed037065471c4b6a20d9a64b91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderWithSimpleMenu_authenticationConfig",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimpleMenuMainNavigation_authenticationConfig"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "f0085640541d036ed0bbd0b9eb071d52";

module.exports = node;
